import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import RABillRecommended from './RABillRecommended';

const RABillSubmission = Loadable(lazy(() => import('./RABillSubmission')));
const RABillVerification = Loadable(lazy(() => import('./RABillVerification')));
const RABillApproval = Loadable(lazy(() => import('./RABillApproval')));
const RABillAmendment = Loadable(lazy(() => import('./RABillAmendment')));

const raBillRoutes = [
  {
    path: '/RABillSubmission',
    element: <RABillSubmission />,
  },
  {
    path: '/RABillVerification',
    element: <RABillVerification />,
  },
  {
    path: '/RABillApproval',
    element: <RABillApproval />,
  },
  {
    path: '/RABillAmendment',
    element: <RABillAmendment />,
  }, {
    path: '/BillRecommendation',
    element: <RABillRecommended />,
  }


  //RABillSubmission
  //RABillVerification
  //RABillApproval
  //RABillRecovery
  //RABillAmendment
];

export default raBillRoutes;